import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogButton from "@/shared/ui/SogButton.vue";
import ProductPrice from "@/shared/model/productPrice";
import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogSvgIcon from "@/shared/ui/SogSvgIcon.vue";
import {mdiFileDocument, mdiStore, mdiWeb} from "@mdi/js";
import {computed} from "vue";

interface Props {
  productPrice: ProductPrice,
  visiblePrice?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductPriceButtonComponent',
  props: {
    productPrice: {},
    visiblePrice: { type: Boolean, default: true }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit


function onClick(value: ProductPrice) {
  emit("click", value)
}

const _price = computed(() => {
  if (props.productPrice.minSaleGrossPrice)
    return props.productPrice.minSaleGrossPrice
  return props.productPrice.grossPrice > (props.productPrice.minSaleGrossPrice ?? 0) ? props.productPrice.grossPrice : props.productPrice.minSaleGrossPrice
})

const _tooltip = computed(()=>{
  if(props.productPrice.isJustInTime){
    return "Online bestellen";
  }
  if(props.productPrice.isStore){
    return "Aus Lager";
  }
  if(props.productPrice.isStoreExportBlank){
    return "Vorgedruckte Formular";
  }
  return "";
})


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(SogButton, {
    tooltip: _tooltip.value,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick(__props.productPrice)))
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(__props.productPrice.carTypeName), 1),
        _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1))
      ], 512), [
        [_vShow, __props.productPrice.isInsurance]
      ]),
      _withDirectives(_createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(__props.productPrice.territoryTypeName ?? __props.productPrice.validityDay), 1),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
      ], 512), [
        [_vShow, __props.productPrice.isInsurance]
      ]),
      _createTextVNode(" " + _toDisplayString(__props.productPrice.manufacturerName), 1),
      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("span", null, [
        _withDirectives(_createVNode(SogDataLabel, {
          value: _price.value,
          "value-type": _unref(SogDataLabelValueType).Money
        }, null, 8, ["value", "value-type"]), [
          [_vShow, __props.visiblePrice]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))
      ]),
      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiWeb) }, null, 8, ["icon"]), [
        [_vShow, __props.productPrice.isJustInTime]
      ]),
      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiStore) }, null, 8, ["icon"]), [
        [_vShow, __props.productPrice.isStore]
      ]),
      _withDirectives(_createVNode(SogSvgIcon, { icon: _unref(mdiFileDocument) }, null, 8, ["icon"]), [
        [_vShow, __props.productPrice.isStoreExportBlank]
      ])
    ]),
    _: 1
  }, 8, ["tooltip"])), [
    [_vShow, __props.productPrice]
  ])
}
}

})